import { useFitnessStore } from '../../../store/fitnessStore';
import { Lock } from 'lucide-react';

export default function PaywallBanner({ feature, requiredTier = 'pro', children }) {
  const openModal = useFitnessStore((s) => s.openModal);

  return (
    <div className="relative">
      <div className="pointer-events-none opacity-30 select-none">{children}</div>
      <div
        className="absolute inset-0 flex flex-col items-center justify-center rounded-2xl"
        style={{ background: 'rgba(10,10,11,0.85)', backdropFilter: 'blur(4px)' }}
      >
        <Lock size={24} color="#E8FF47" style={{ marginBottom: 8 }} />
        <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 4 }}>
          {requiredTier === 'elite' ? '⚡ Elite Feature' : '🔓 Pro Feature'}
        </div>
        <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.5)', marginBottom: 12, textAlign: 'center', maxWidth: 200 }}>
          Unlock {feature} with {requiredTier === 'elite' ? 'Elite' : 'Pro'}
        </div>
        <button
          type="button"
          onClick={() => openModal('upgrade')}
          style={{ background: '#E8FF47', color: '#0A0A0B', border: 'none', borderRadius: 10, padding: '9px 18px', fontWeight: 600, fontSize: 13, cursor: 'pointer' }}
        >
          Upgrade — {requiredTier === 'elite' ? '$19.99/mo' : '$9.99/mo'}
        </button>
      </div>
    </div>
  );
}
